import React, { useEffect, useState } from 'react';
import { Container, Alert, Spinner, Card, Row, Col, Table, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataManager } from '../../../core/data-manager';
import { LanguageProvider } from '../../../core/language-provider';
import { ViewManager } from '../../../core/view-manager';
import ModalViewFile from '../../../components/Modals/ModalViewFile';
import ModalDelete from '../../../components/Modals/ModalDelete';
import FileField from '../../../components/Fields/File';
import { ApiManager } from '../../../core/api-manager';
import { toast } from 'react-toastify';


export default function VoyageDocuments({voyageId}) {

    const [errors, setErrors] = useState('');
    const [properties, setProperties] = useState(null);
    const [voyage, setVoyage] = useState(null);
    const [data, setData] = useState({
        type: null,
        file: null,
        idVoyage: {id: voyageId}
    });
    


    async function init() {
        if(voyageId !== null) {
            var response = await DataManager.getItem('voyage', voyageId);
            if(response.success === 1) {
                var v = response.body[0]
                setVoyage(v)
                console.warn("voyage", v)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
            }
        }
    }

    useEffect(() => {
        async function getProperties() {
            var props = ViewManager.getEntityProperties('voyage_documents')
            setProperties(props)
            console.warn("properties", props)
        }
        getProperties()
        init()

    }, []);


    function saveField(field, value) {
        console.warn(field, value)
        setDataKeyValue(field, value)
    }

    function setDataKeyValue(key, value) {
        setData((prevState) => ({
            ...prevState,
            [key]: value
        }));
    }

    async function save() {
        console.warn(data)
        if(data.type === null || data.file === null) {
            setUploadMessageType('warning')
            setUploadMessage("Completa tutti i campi qui sopra e riprova. E' obbligatorio selezionare un tipo file.")
            console.warn(response)
        }
        else {
            var response = await DataManager.insertItem("voyage_documents", data);
            if(response.success === 1) {
                setUploadMessageType('success')
                setUploadMessage('File caricato con successo')
                setDataKeyValue("type", null)
                setDataKeyValue("file", null)
                init()
            }
            else {
                setUploadMessageType('danger')
                setUploadMessage(LanguageProvider.get('errors.insert'))
                console.warn(response)
            }
        }
        setTimeout(() => {
            setUploadMessage('')
        }, "5000")
    }

    const [uploadMessage, setUploadMessage] = useState('');
    const [uploadMessageType, setUploadMessageType] = useState('danger');


    // resource
    const [modalViewFileData, setModalViewFileData] = useState(null)
    const [modalDeleteData, setModalDeleteData] = useState(null)
    function viewFile(res) {
        setModalViewFileData(res)
    }
    function closeModalViewFile() {
        setModalViewFileData(null)
    }
    function deleteFile(item) {
        setModalDeleteData(item)
    }
    function closeModalDelete() {
        setModalDeleteData(null)
    }
    async function confirmModalDelete(item) {
        init()
        setModalDeleteData(null)
    }



    if (voyage !== null && properties !== null) {
        return (
            <>
                <Row>
                    <Col xs={12} md={7}>
                        <Card className='mb-3' style={{ backgroundColor: '#f3f3f3' }}>
                            <Card.Body>
                                <h4>File caricati</h4>
                                {voyage.documents ? (
                                    <>
                                        <Table bordered responsive className="small mb-3">
                                            <tbody>
                                                {voyage.documents && voyage.documents.length > 0 ? ( 
                                                    <>
                                                        {voyage.documents.map((document, j) => {
                                                            var optionVPkey = 'type.options.' + document.type.value
                                                            return (
                                                                <tr key={j}>
                                                                    <td>
                                                                        Tipo file: <b>{LanguageProvider.getLabel("voyage_documents", optionVPkey)}</b><br/>
                                                                        Data caricamento: {document.date}<br/>
                                                                        <span className='text-muted small'>Peso file: {document.file && document.file.size ? (document.file.size / 1024).toFixed(2) : 0} Kb</span>
                                                                    </td>
                                                                    <td>
                                                                        <span onClick={() => viewFile(document.file)} role='button' className='link-primary'>Visualizza file</span>
                                                                        <br/>
                                                                        <span onClick={() => deleteFile(document)} role='button' className='link-danger'>Elimina file</span>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </tbody>
                                        </Table>
                                    </>
                                ) : (
                                    <Alert variant='warning'>
                                        Non è presente alcun documento per questo viaggio
                                    </Alert>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} md={5}>
                        <Card className='mb-3' style={{ backgroundColor: '#f3f3f3' }}>
                            <Card.Body>
                                <h4>Carica file</h4>
                                <Form.Group>
                                    <Form.Label className='small'>Tipo file</Form.Label>
                                    <Form.Select onChange={(event) => saveField('type', {'value': event.target.value, 'label': event.target.value})} value={data.type !== null && data.type.value}>
                                        <option value='null'>Seleziona</option>
                                        {properties.columns.type.options.options.map((option, w) => {
                                            var optionVPkey = 'type.options.' + option.value
                                            return (
                                                <option key={w} value={option.value}>{LanguageProvider.getLabel('voyage_documents', optionVPkey)}</option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form.Group>
                                <br/>
                                <FileField entity={'voyage_documents'} label={'Carica File'} field={'file'} options={{}} validation={{type: 'file'}} value={data.file} update={saveField} />
                                <br/>
                                <Button variant="outline-dark" className='w-100' onClick={() => save()}>Carica file</Button>

                                {uploadMessage.length > 0 &&
                                    <Alert variant={uploadMessageType} className='mt-3'>
                                        {uploadMessage}
                                    </Alert>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                
                <ModalViewFile data={modalViewFileData} closeModalViewFile={closeModalViewFile} />
                <ModalDelete entity={'voyage_documents'} props={properties} data={modalDeleteData} closeModalDelete={closeModalDelete} confirmModalDelete={confirmModalDelete} />
            
            </>
        )
    }
    else {
        return (
            <Container fluid='md' className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};